import { useEffect, useState } from "react";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { SelectBudgetTypes } from "../../../erp/cellEditor/AccountantConcept/SelectBudgetTypes";
import { SelectBudgetType } from "../../../admin/configuracion/select/SelectBudgetType";


interface Props {

    onChange: Function;
}
export const TraslateForm = ({ onChange }: Props) => {

    const [response, setResponse] = useState<any>({});

    useEffect(() => {
        setResponse({
            Year: new Date().getFullYear(),
            YearTO: new Date().getFullYear(),
            IDBudgetType: undefined,
            Type: undefined,
            Observation: ""
        })
    }, [])
    useEffect(() => {
        onChange(response)
    }, [response])

    return (
        <div className="row">
            <div className="col-md-3">
                <label htmlFor="">Año Origen</label>
                <YearSelector value={response.Year} onChange={(e) => { setResponse({ ...response, ['Year']: e }) }} />
            </div>
            <div className="col-md-3">
                <label htmlFor="">Año Destino</label>
                <YearSelector value={response.YearTO} onChange={(e) => { setResponse({ ...response, ['YearTO']: e }) }} />
            </div>
            <div className="col-md-3">
                <SelectBudgetTypes label="Tipo de Presupuesto" idSelector={response.IDBudgetType} onChange={(e) => { setResponse({ ...response, ['IDBudgetType']: e }) }} />
            </div>
            <div className="col-md-3">
                <SelectBudgetType label="Presupuesto Destino" idType={response.IDBudgetType} idSelector={response.Type} onChange={(e) => { setResponse({ ...response, "Type": parseInt(e) }) }} />
            </div>
            <div className="col-md-12">
                <label>Observacion</label>
                <textarea className="form-control" value={response.Observation} onChange={(e) => { setResponse({ ...response, "Observation": e.target.value }) }} />
            </div>

        </div>
    )
}